import React from "react";

import ButtonPlaceholder from "components/ButtonPlaceholder";
import Placeholder, { Rect } from "components/Placeholder";
import { MenuCardSkeleton } from "components/Shared/Skeletons";

const SearchResultsPlaceholder: React.FC<{
  buttonWidth?: string;
  count?: number;
}> = ({ count = 4, buttonWidth = "100%" }) => {
  return (
    <div className="container">
      <div className="mb-lg">
        <Placeholder width="100%" height="56">
          <Rect width="132" height="32" />
          <Rect y="36" width="132" height="24" />
        </Placeholder>
      </div>
      <div className="flex flex-row overflow-auto lg:overflow-hidden mb-lg -mx-sm p-sm pb-md scroll-px-sm">
        <ul className="inline-flex lg:flex -mr-sm lg:mr-none">
          {new Array(count).fill(null).map((_, i) => {
            return (
              <li className="flex-shrink-0 mr-md" key={i}>
                <MenuCardSkeleton className="bg-white" />
              </li>
            );
          })}
        </ul>
      </div>
      <div className="mb-md">
        <ButtonPlaceholder height="48" width={buttonWidth} />
      </div>
      <div className="mt-section">
        <Placeholder width="100%" height="227">
          <Rect width="992" height="227" />
        </Placeholder>
      </div>
    </div>
  );
};

export default SearchResultsPlaceholder;
